/**
 * Leaf = node with no non-archived children.
 * Archived children do not make a node a parent for assignment purposes.
 */

function listNodes(nodesByIdOrList) {
  if (!nodesByIdOrList) return []
  if (Array.isArray(nodesByIdOrList)) return nodesByIdOrList.filter((n) => n?.id)
  if (typeof nodesByIdOrList.values === 'function') return Array.from(nodesByIdOrList.values())
  return Object.keys(nodesByIdOrList)
    .map((id) => nodesByIdOrList[id])
    .filter((n) => n?.id)
}

export function getNonArchivedChildren(nodeId, nodesByIdOrList) {
  if (!nodeId) return []
  return listNodes(nodesByIdOrList).filter(
    (node) => node.parentId === nodeId && node.isArchived !== true
  )
}

export function isCatalogTaxonomyLeafNode(nodeId, nodesByIdOrList) {
  if (!nodeId) return false
  return getNonArchivedChildren(nodeId, nodesByIdOrList).length === 0
}
